<nav class="navbar navbar-expand-lg navbar-light bg-light sticky" id="mainNav" style="z-index: 80;">
    <div class="container-fluid">
        <a class="navbar-brand" routerLink="home">
            <img src="../../assets/img/logo.jpg" alt="" width="180" height="90" style="padding: auto;">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">

            <ul class="navbar-nav me-auto" style="margin-left: 20px;">
                <li class="nav-item">
                    <a class="nav-link" routerLink="./">Home |</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/blog">Blog </a>
                </li>
            </ul>

            <div class>
                <ul class="navbar-nav ms-auot">
                    <li><a class="nav-link" id="sign-in" routerLink="/student-login">Sign in</a></li>
                    <li><a class="nav-link" id="sign-up" routerLink="/student-reg">Sign up</a></li>
                    <li><a class="nav-link" id="sign-up" routerLink="/admin-login">Admin</a></li>
                </ul>
            </div>

        </div>
    </div>
</nav>
<!-- Header -->
<header name="home" style="display: flex;justify-content: center;align-items: center;">

    <div class="container">

        <div class="container-title">
            <h3>TUT</h3>
            <h3>Online</h3>
            <h3>Orientation</h3>
        </div>
        <div style="display: flex; justify-content: center;z-index: 40;">
            <a routerLink="/student-login" (click)="startOr()"
                style=" justify-content: center;border-radius: 25px; border-width: 20px;" class="myButton">Start
                Orientation
                <em class="ml-2" data-feather="arrow-right"></em>
            </a>
        </div>
        <div class="container-role">
            <h3>For first time students</h3>
        </div>

    </div>

    <div class="intro-text">
        <mdb-carousel [animation]="'fade'" style="z-index: -10;">
            <mdb-carousel-item style="height:1300px;width:100%">
                <img style="object-fit: cover;" src="../../assets/img/ori29 (2 of 16) - Copy.jpg"
                    class="d-block w-100 h-100" alt="..." />
            </mdb-carousel-item>
            <mdb-carousel-item style="height:1300px;width:100%">
                <img style="object-fit: cover;" src="../../assets/img/ori29 (12 of 16).jpg" class="d-block w-100 h-100"
                    alt="..." />
            </mdb-carousel-item>
            <mdb-carousel-item style="height:1300px;width:100%">
                <img style="object-fit: cover;" src="../../../assets/img/ori31 (26 of 32).jpg"
                    class="d-block w-100 h-100" alt="..." />
            </mdb-carousel-item>
            <mdb-carousel-item style="height:1300px;width:100%">
                <img style="object-fit: cover;" src="../../assets/img/ori29 (16 of 16).jpg" class="d-block w-100 h-100"
                    alt="..." />
            </mdb-carousel-item>
            <mdb-carousel-item style="height:1300px;width:100%">
                <img style="object-fit: cover;" src="../../assets/img/ori31 (25 of 32).jpg" class="d-block w-100 h-100"
                    alt="..." />
            </mdb-carousel-item>
            <mdb-carousel-item style="height:1300px;width:100%">
                <img style="object-fit: cover;" src="../../assets/img/ori29 (11 of 16).jpg" class="d-block w-100 h-100"
                    alt="..." />
            </mdb-carousel-item>
        </mdb-carousel>
    </div>
</header>